<script setup lang="ts">
import WhiteBox from '@/components/WhiteBox.vue'
import Tip from '@shared/components/Tip.vue'

type Props = {
    title?: string
    icon?: string
    tip?: string
    link?: string
    linkTitle?: string
}

const { title, icon, tip, link, linkTitle } = defineProps<Props>()
</script>

<template>
    <white-box class="w-full max-w-[450px] md:w-[370px] ml-auto">
        <h2 v-if="title" class="text-lg lg:text-xl flex items-center gap-3">
            <i v-if="icon" class="lni" :class="icon"></i>

            <span>{{ title }}</span>

            <tip v-if="tip" :content="tip" :icon="true" />
        </h2>

        <div v-if="link && linkTitle">
            <a :href="link" class="text-main hover:underline text-[.9rem]" target="_blank">
                {{ linkTitle }}
            </a>
        </div>

        <div :class="{ 'mt-5 lg:mt-6': title }">
            <slot />
        </div>
    </white-box>
</template>
